import React, { useState } from "react";
import { ChevronDown, ChevronUp, Loader2, RefreshCw } from "lucide-react";
import { toast } from "../../../components/ui/sonner";

/* 加州加班拆分明细：常规 / 1.5x / 2x 汇总 + 每周（周一–周日）每日明细 + 「按加州规则重算」 */
export function UsOtDetail({ api, run, zh, onRecalc }) {
  const T = (z, e) => (zh ? z : e);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const a = run.attendance || {};
  const weeks = a.weeks || [];
  const recalc = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/hrms/us-payroll/runs/${run.id}/recalc-ot`); toast.success(T(`已按加州规则重算：常规 ${data.inputs.regularHours}h · 1.5x ${data.inputs.ot15Hours}h · 2x ${data.inputs.ot20Hours}h`, `Recalculated: regular ${data.inputs.regularHours}h · 1.5x ${data.inputs.ot15Hours}h · 2x ${data.inputs.ot20Hours}h`)); onRecalc?.(data); }
    catch (e) { toast.error(e?.response?.data?.detail || T("重算失败", "Failed")); }
    setBusy(false);
  };
  return (
    <div className="rounded-md bg-slate-50 border border-slate-100 px-2 py-1.5 text-[11px] text-slate-600" data-testid="us-run-attendance">
      <div className="flex items-center gap-2">
        <span data-testid="us-run-ot-summary">{T(`考勤 ${a.hours ?? 0}h → 常规 ${a.regular ?? 0}h · 1.5x ${a.ot15 ?? 0}h · 2x ${a.ot20 ?? 0}h`, `Timeclock ${a.hours ?? 0}h → regular ${a.regular ?? 0}h · 1.5x ${a.ot15 ?? 0}h · 2x ${a.ot20 ?? 0}h`)}</span>
        <button type="button" data-testid="us-run-recalc-ot" disabled={busy} onClick={recalc} title={T("从考勤按加州规则重算小时（覆盖手改）", "Recalculate hours from timeclock per CA rules (overrides manual edits)")}
          className="ml-auto inline-flex items-center gap-1 rounded-full border border-indigo-200 text-indigo-700 hover:bg-indigo-50 px-2 py-0.5 font-semibold disabled:opacity-50">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <RefreshCw className="h-3 w-3" />}{T("按加州规则重算", "Recalc (CA rules)")}
        </button>
        {weeks.length > 0 && <button type="button" data-testid="us-run-ot-toggle" onClick={() => setOpen((o) => !o)} className="text-slate-400 hover:text-slate-700">{open ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}</button>}
      </div>
      <p className="text-[10px] text-slate-400 mt-0.5">{T("加州规则：日 >8h ×1.5 · >12h ×2 · 连续第 7 天前 8h ×1.5 余 ×2 · 周常规 >40h ×1.5（周一–周日）", "CA rules: daily >8h ×1.5 · >12h ×2 · 7th consecutive day first 8h ×1.5 then ×2 · weekly straight-time >40h ×1.5 (Mon–Sun)")}</p>
      {open && (
        <div className="mt-1.5 space-y-1.5" data-testid="us-run-ot-detail">
          {weeks.map((w) => (
            <div key={w.weekStart} className="rounded border border-slate-200 bg-white p-1.5" data-testid={`us-run-ot-week-${w.weekStart}`}>
              <p className="font-semibold text-slate-700">{w.weekStart} – {w.weekEnd} · {T(`${w.daysWorked} 天`, `${w.daysWorked} days`)} · {T("常规", "Reg")} {w.regular}h · 1.5x {w.ot15}h · 2x {w.ot20}h
                {w.weeklyOt > 0 && <span className="text-amber-700 ml-1">{T(`（周 >40h 转 1.5x：${w.weeklyOt}h）`, `(weekly >40h → 1.5x: ${w.weeklyOt}h)`)}</span>}
                {w.seventhDay && <span className="text-red-600 ml-1">{T("（连续第 7 天）", "(7th consecutive day)")}</span>}</p>
              <div className="grid grid-cols-7 gap-1 mt-1">
                {w.days.map((d) => (
                  <div key={d.date} className={`rounded px-1 py-0.5 text-center ${d.seventh ? "bg-red-50" : d.ot20 > 0 ? "bg-amber-50" : d.ot15 > 0 ? "bg-indigo-50" : "bg-slate-50"}`} title={`${d.date} · ${d.hours}h`}>
                    <p className="text-[9px] text-slate-400">{d.date.slice(5)}</p>
                    <p className="font-mono text-[10px]">{d.hours}h</p>
                    <p className="text-[9px] text-slate-500">{d.regular}/{d.ot15}/{d.ot20}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
